import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ShoppingBag } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { Seo } from "@/components/Seo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404: route not found:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <Seo
        title="Siden ble ikke funnet – Håp Naturlab"
        description="Denne siden finnes ikke. Gå tilbake til forsiden eller utforsk nettbutikken."
        noIndex
      />
      <section className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-6 py-20 text-center">
        <p className="font-heading text-7xl font-bold text-primary md:text-9xl">404</p>
        <h1 className="mt-6 font-heading text-3xl font-bold md:text-4xl">
          Her var det stille…
        </h1>
        <p className="mt-4 max-w-md text-lg text-muted-foreground font-body">
          Siden du leter etter finnes ikke lenger, eller har flyttet på seg.
          Kanskje du finner det du trenger et annet sted?
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-8 py-3.5 font-body text-sm font-semibold text-primary-foreground shadow-lg transition-all hover:opacity-90 hover:-translate-y-0.5"
          >
            <Home className="h-4 w-4" />
            Til forsiden
          </Link>
          <Link
            to="/nettbutikk"
            className="inline-flex items-center gap-2 rounded-full border-2 border-primary px-8 py-3.5 font-body text-sm font-semibold text-primary transition-all hover:bg-primary hover:text-primary-foreground"
          >
            <ShoppingBag className="h-4 w-4" />
            Til butikken
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
